import React from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Download,
} from '../../../components';

import './style.scss';

const ParagraphDownloads = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const downloads = entity.getIn(['field_downloads']);

  return (
    <Container className="ParagraphDownloads">
      <div className="row">
        <div className="ParagraphDownloads__inner col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
          <h3 className="ParagraphDownloads__title">{title}</h3>
          <WysiwygField
            property="schema:text"
            className="ParagraphDownloads__body"
            html={body}
          />
          {downloads.map((download, index) => {
            const downloadTitle = download.get('title');
            return (
              <Download key={downloadTitle} download={download} />
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphDownloads;
